import React from 'react';

type EvidenceStatus = 'UPLOADING' | 'UPLOADED' | 'PROCESSING' | 'PROCESSED' | 'FAILED';

const STATUS_STYLES: Record<EvidenceStatus, { label: string; className: string }> = {
  UPLOADING: { label: 'Uploading', className: 'bg-gray-100 text-gray-700' },
  UPLOADED: { label: 'Uploaded', className: 'bg-gray-100 text-gray-700' },
  PROCESSING: { label: 'Processing', className: 'bg-yellow-100 text-yellow-700' },
  PROCESSED: { label: 'Done', className: 'bg-green-100 text-green-700' },
  FAILED: { label: 'Failed', className: 'bg-red-100 text-red-700' },
};

export interface EvidenceStatusBadgeProps {
  status: EvidenceStatus;
  labelOverride?: string;
}

const EvidenceStatusBadge: React.FC<EvidenceStatusBadgeProps> = ({ status, labelOverride }) => {
  const config = STATUS_STYLES[status] || STATUS_STYLES.UPLOADED;
  return (
    <span className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-medium ${config.className}`}>
      {labelOverride || config.label}
    </span>
  );
};

export default EvidenceStatusBadge;
